import type { GetStaticProps, NextPage } from "next";
import { SiteLayout } from "src/domains/shared/components/Home/SiteShell/SiteLayout";
import { ReleasesPage } from "src/domains/shared/components/Home/Releases/ReleasesPage";

const Releases: NextPage = () => (
  <SiteLayout>
    <ReleasesPage />
  </SiteLayout>
);

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};

export default Releases;
